import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {MenuItem} from "../../../../common";

/**
 * item card for quick selection / flattened order view
 * NOTE: This is only used in select-benefit component. You want <menu-item> instead.
 */
@Component({
  selector: 'item-card',
  standalone: false,
  template: `
    <div class="card mt-3 mb-3">
      <img class="card-img-top" [src]="item.image" alt="{{ item.name}}" *ngIf="showImage && item.image">
      <div class="card-body">
        <div class="card-title h5 row">
          <div class="col">{{ item.name }}
            <div *ngIf="item.quantity && !item.hasVariants()" class="text-muted"><small>{{ item.quantity }}</small>
            </div>
          </div>
          <div class="col-auto text-right" *ngIf="showPrice && !item.hasVariants()">{{ item.price|currency:item.menu.host }}</div>
        </div>
        <div class="form">
          <div *ngIf="item.hasVariants()" class="mt-3">
            <h6 i18n>Variants</h6>
            <div class="form-check" *ngFor="let variant of item.variants">
              <input class="form-check-input hide-validation-status" type="radio"
                     name="variant" [value]="variant.id" id="v_{{ variant.id }}"
                     [(ngModel)]="selectedVariant" />
              <label class="form-check-label row" for="v_{{ variant.id }}">
                <div class="col">{{ variant.name }} <span *ngIf="variant.quantity">({{variant.quantity}})</span></div>
                <div class="col-auto text-right" *ngIf="showPrice">{{ variant.price|currency:item.menu.host }}</div>
              </label>
            </div>
          </div>
          <div *ngIf="item.hasOptions() && showOptions" class="mt-3">
            <h6 i18n>Options</h6>
            <div class="form-check" *ngFor="let option of item.getOptions()">
              <input [(ngModel)]="selectedOptions[option.id]" class="form-check-input hide-validation-status"
                     type="checkbox" name="option" id="o_{{ option.id }}" value="{{ option.id }}">
              <label class="form-check-label row" for="o_{{ option.id }}">
                <div class="col">{{ option.name }}</div>
                <div class="col-auto text-right">{{ option.price|currency:item.menu.host }}</div>
              </label>
            </div>
          </div>
          <p class="text-center mt-3 mb-0" *ngIf="buttonText">
              <button type="button" [class]="buttonClass" (click)="onButtonClick()">
                <i [class]="iconClass"></i>&nbsp;<span>{{ buttonText }}</span>
              </button>
            </p>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class ItemCard implements OnInit {
  @Input() item: MenuItem;
  @Input() showImage: boolean = false;
  @Input() showOptions: boolean = false;
  @Input() showPrice: boolean = false;
  @Input() buttonText: string;
  @Input() buttonClass: string = 'btn btn-primary order-button';
  @Input() iconClass: string = 'fas fa-hand-point-up';
  @Output() clickButton = new EventEmitter<number>();

  selectedVariant: number;
  selectedOptions: Map<number, boolean>;

  ngOnInit(): void {
    if (this.item.hasVariants()) {
      this.selectedVariant = this.item.getDefaultVariantId();
    }
    if (this.item.hasOptions()) {
      this.selectedOptions = new Map<number, boolean>();
    }
  }

  onButtonClick() {
    this.clickButton.emit(this.selectedVariant);
  }
}

